import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import pathToRegexp from 'path-to-regexp';
import { createElement, FC, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

import { sidebarBackground } from '../../../constant/color';

interface Props {
  onClick: MouseEventHandler<HTMLElement>;
  path: string;
  dataIntercomTarget: string;
  messageId: string;
}

const SideBarInternalLinkMenuButton: FC<Props> = ({ onClick, path, dataIntercomTarget, messageId }) => {
  return (
    <MenuButton
      style={pathToRegexp(path).test(location.pathname) ? { background: sidebarBackground } : {}}
      onClick={onClick}
      data-intercom-target={dataIntercomTarget} // intercom の Product Tour で使用
    >
      <Label>
        <FormattedMessage id={messageId} />
      </Label>
    </MenuButton>
  );
};

const MenuButton = styled(Button)({
  lineHeight: '1.1875rem',
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  width: '208px',
  height: '40px',
  borderRadius: '8px',
  cursor: 'pointer',
  justifyContent: 'unset',
  backgroundColor: 'transparent',
  '&:hover': {
    background: sidebarBackground,
    boxShadow: 'unset',
  },
});

const Label = styled(Typography)({
  color: '#4c566b',
  fontWeight: 700,
  fontSize: '14px',
  margin: '10px 16px',
  whiteSpace: 'nowrap',
});

Label.defaultProps = { variant: 'caption' };

export default SideBarInternalLinkMenuButton;
